// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/DollarCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var DollarCircleOutlined = function DollarCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleOutlinedSvg
  }));
};

DollarCircleOutlined.displayName = 'DollarCircleOutlined';
export default React.forwardRef(DollarCircleOutlined);